/* import __COLOCATED_TEMPLATE__ from './fin-tutorials-modal.hbs'; */
/* RESPONSIBLE TEAM: team-fin-nux */
import { action } from '@ember/object';
import Component from '@glimmer/component';

interface Signature {
  Args: {
    model: {
      tutorialId: string;
      place: string;
      section: string;
      onOpenChange: (open: boolean) => void;
    };
  };
}

export default class FinTutorialsModal extends Component<Signature> {
  constructor(owner: unknown, args: any) {
    super(owner, args);
  }

  @action
  onOpenChange(open: boolean) {
    this.args.model?.onOpenChange(open);
  }
}

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'React::FinTutorials::FinTutorialsModal': typeof FinTutorialsModal;
    'react/fin-tutorials/fin-tutorials-modal': typeof FinTutorialsModal;
  }
}
